export interface Measurement {
    id: string;
    label: string;
    tag: string;
    unit: string;
    format: string;
    min: number;
    max: number;
    suggestMin: number;
    suggestMax: number;
    defaultChart: string;
    defaultBucket: string;
    subjectId: string;
}

export enum ConversionSystem {
    METRIC = 'METRIC',
    IMPERIAL = 'IMPERIAL',
}

export enum Units {
    MM = 'mm',
    M = 'm',
    G  = 'g',
    KG = 'kg',
    IN = 'in',
    LB = 'lb',
    FT = 'ft',
}

export interface UnitDefinition {
    toStandard: (val: number) => number;   // e.g., lbs to kg
    fromStandard: (val: number) => number; // e.g., kg to lbs
    symbol: string;
}

type MetricUnits = Units.G | Units.KG | Units.MM | Units.M;

export const MetricToImperial: Record<MetricUnits, { factor: number; target: string }> = {
    [Units.G]:  { factor: 0.035274,  target: 'oz' },
    [Units.KG]: { factor: 2.20462,   target: 'lb' },
    [Units.MM]: { factor: 0.0393701, target: 'in' },
    [Units.M]:  { factor: 3.28084,   target: 'ft' },
};

export function toImperial(value: number, unit: Units) {
    if (unit in MetricToImperial) {
        const conversion = MetricToImperial[unit as MetricUnits];
        return {
            value: Number((value * conversion.factor).toFixed(2)),
            unit: conversion.target
        };
    }

    return { value, unit };
}

